import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Tooth } from '@modules/teeth-diagram/models/tooth';

import {
	RxIntuitiveImplantBasedDentureModalComponent,
	RxIntuitiveImplantBasedDentureModalData,
	RxIntuitiveImplantBasedDentureModalResult
} from './rx-intuitive-implant-based-denture-modal.component';
import { IntuitiveToothForDiagram } from '../../models/intuitive-tooth-for-diagram';
import { ToothModalOpenOptions, ToothModalService } from '../../models/tooth-modal';

@Injectable({ providedIn: 'root' })
export class ImplantBasedDentureModalService implements ToothModalService {
	constructor(private readonly modalService: TlkModalWindowService) {}

	/**
	 * Opens the implant-based denture modal (scan body + implant manufacturers, implant type).
	 * @param teeth - Mapped teeth view models to display
	 * @param initialTooth - Initial tooth data (ImplantTypeID)
	 * @returns Observable that emits partial Tooth updates or null if cancelled
	 */
	open(
		teeth: IntuitiveToothForDiagram[],
		initialTooth: Tooth,
		options?: ToothModalOpenOptions
	): Observable<RxIntuitiveImplantBasedDentureModalResult> {
		void options;

		const modalData: RxIntuitiveImplantBasedDentureModalData = {
			teeth,
			initialImplantTypeId: initialTooth?.ImplantTypeID ?? null
		};

		const dialogRef = this.modalService.open(RxIntuitiveImplantBasedDentureModalComponent, {
			panelClass: 'rx-intuitive-implant-based-denture-modal-dialog',
			data: modalData,
			autoFocus: true,
			disableClose: true
		});

		return dialogRef.closed.pipe(map((result: RxIntuitiveImplantBasedDentureModalResult) => result));
	}
}
